// ONE POS brendi (Q-032): logotip fayllari va ishlatish qoidalari. Hamkor, dizayner yoki bosmaxonaga
// shu sahifadan yuklab beriladi. Fayllar public/brand/ da (belgi chizmasidan yaratilgan, docs/BREND.md).
import { BRAND, BrandLockup, BrandMark, Card, Icon } from '@onepos/ui';

const FILES: { file: string; label: string; note: string; dark?: boolean }[] = [
  { file: 'one-pos-logotip.svg', label: 'Logotip', note: 'Oq yoki och fonda — asosiy variant' },
  {
    file: 'one-pos-logotip-oq.svg',
    label: 'Logotip, oq',
    note: 'Zumrad yoki to‘q fonda',
    dark: true,
  },
  {
    file: 'one-pos-logotip-tik.svg',
    label: 'Logotip, tik',
    note: 'Kvadrat joylar: stiker, eshik, kiyim',
  },
  { file: 'one-belgi.svg', label: 'Belgi', note: 'Yozuvsiz, 32 px va kattaroq' },
  { file: 'one-belgi-oq.svg', label: 'Belgi, oq', note: 'To‘q fonda', dark: true },
  { file: 'one-belgi-qora.svg', label: 'Belgi, bir rang', note: 'Muhr, chek, faks, gravyura' },
  { file: 'one-belgi-kichik.svg', label: 'Kichik belgi', note: '32 px dan kichik: ikonka, yorliq' },
  {
    file: 'one-belgi-kichik-oq.svg',
    label: 'Kichik belgi, oq',
    note: 'To‘q fonda, 32 px dan kichik',
    dark: true,
  },
  { file: 'one-pos-ilova-512.png', label: 'Ilova ikonkasi', note: 'PNG, 512 × 512' },
];

const COLORS: { hex: string; name: string; use: string; line?: boolean }[] = [
  { hex: BRAND.emerald, name: 'Chuqur zumrad', use: 'Asosiy rang: belgi, kirish sahifasi, ikonka' },
  { hex: BRAND.saffron, name: 'Zafaron', use: 'Faqat yulduz va kichik urg‘u. Katta maydonga emas' },
  { hex: BRAND.ink, name: 'Siyoh', use: 'Matn va “POS” so‘zi' },
  { hex: BRAND.mist, name: 'Och fon', use: 'Yumshoq fon, kartochkalar', line: true },
];

const RULES_DO = [
  'Belgi atrofida kamida yulduz kengligicha bo‘sh joy qoldiring (belgining beshdan biri).',
  'To‘liq belgi kamida 32 px; undan kichikda “kichik belgi” faylini ishlating.',
  'Yozuvli logotip balandligi ekranda kamida 24 px, qog‘ozda kamida 8 mm.',
  'Fon: oq, och fon yoki zumrad. Rasm ustida — oq variant va to‘q, tinch joyda.',
  'Restoran ekranlarida restoranning o‘z logosi birinchi, ONE POS — faqat kichik imzo.',
];

const RULES_DONT = [
  'Ranglarni almashtirmang, gradient, soya yoki kontur qo‘shmang.',
  'Belgini burmang, cho‘zmang, qiyshaytirmang.',
  'Yulduzni olib tashlamang va uning rangini o‘zgartirmang (bir rangli variantdan tashqari).',
  'Belgi qismlarini alohida ishlatmang, harflar tartibini o‘zgartirmang.',
  '“ONE POS” yozuvini boshqa shriftda qayta yozmang — tayyor fayldan foydalaning.',
];

export function BrandPage() {
  return (
    <>
      <header className="cn-page-head">
        <div>
          <h1>Brend</h1>
          <p>ONE POS logotipi, ranglari va ularni ishlatish qoidalari</p>
        </div>
      </header>

      <div className="cn-brandkit">
        <section className="cn-brandkit__hero cn-brandkit__hero--light">
          <BrandLockup height={72} tone="color" />
        </section>
        <section className="cn-brandkit__hero cn-brandkit__hero--brand">
          <BrandLockup height={72} tone="white" />
        </section>
      </div>

      <div className="cn-grid cn-brandgrid">
        <Card title="Fayllar" className="cn-brandgrid__wide">
          <ul className="cn-brandfiles">
            {FILES.map((f) => (
              <li key={f.file}>
                <span
                  className={`cn-brandfiles__thumb${f.dark ? ' cn-brandfiles__thumb--dark' : ''}`}
                >
                  <img src={`/brand/${f.file}`} alt="" loading="lazy" />
                </span>
                <span className="cn-brandfiles__text">
                  <b>{f.label}</b>
                  <small>{f.note}</small>
                </span>
                <a className="op-btn op-btn--secondary" href={`/brand/${f.file}`} download={f.file}>
                  <Icon name="download" /> Yuklab olish
                </a>
              </li>
            ))}
          </ul>
        </Card>

        <Card title="Ranglar">
          <ul className="cn-brandcolors">
            {COLORS.map((c) => (
              <li key={c.hex}>
                <span
                  className={`cn-brandcolors__chip${c.line ? ' cn-brandcolors__chip--line' : ''}`}
                  style={{ background: c.hex }}
                />
                <span>
                  <b>{c.name}</b> <code>{c.hex}</code>
                  <small>{c.use}</small>
                </span>
              </li>
            ))}
          </ul>
        </Card>

        <Card title="O‘lchamlar">
          <div className="cn-brandsizes">
            {[96, 64, 40, 32, 24, 16].map((s) => (
              <figure key={s}>
                <BrandMark size={s} tone="auto" />
                <figcaption>{s} px</figcaption>
              </figure>
            ))}
          </div>
          <p className="cn-muted">
            32 px dan kichikda belgi avtomatik soddalashadi: harflar tutashib ketmaydi, yulduz
            ajralib turadi.
          </p>
        </Card>

        <Card title="Qoidalar">
          <h3 className="cn-brandrules__head">Shunday qiling</h3>
          <ul className="cn-brandrules">
            {RULES_DO.map((r) => (
              <li key={r}>
                <Icon name="check" /> {r}
              </li>
            ))}
          </ul>
          <h3 className="cn-brandrules__head">Bunday qilmang</h3>
          <ul className="cn-brandrules cn-brandrules--dont">
            {RULES_DONT.map((r) => (
              <li key={r}>
                <Icon name="x" /> {r}
              </li>
            ))}
          </ul>
        </Card>
      </div>
    </>
  );
}
